// ADR-014 / ADR-016: the render-boundary predicate for the "Not reported"
// off-ramp lens. A row resolved as non-reporting renders dimmed (Done) and joins
// the footer "not reported" pip.
//
// Two resolvedAs values share this lens:
//   - 'Excluded' (ADR-014) — a raw bank line the treasurer pushed off the report
//     (restore-eligible via the bank reopen ↺).
//   - 'Voided'   (ADR-016) — a treasurer-voided money row (Contribution /
//     Expenditure). Same "Not reported" word; restore is the chooser's un-void.
// The legacy 'Transfer' / 'Dismissed' projection values were removed in EFR-003
// after the migration remapped the data.
//
// CONVENTIONS.md hard fence: NEVER compare against `'ExcludedFromReport'` here
// — that string is the BankTransactionAttribution enum value (the persisted /
// wire attribution), NOT the SortInbox `resolvedAs` PROJECTION. The projection
// value is `'Excluded'`; comparing against `'ExcludedFromReport'` ships a
// permanently-dead off-ramp.

import type { TriageResolvedAs } from '@signalvote/shared';

/**
 * True when a triage row's `resolvedAs` projection is a non-reporting
 * resolution — the single source of truth for the "Not reported" lens
 * (dimmed/struck Done rows, the restore eligibility, and the footer pip). Covers
 * both the bank-side `'Excluded'` (ADR-014) and the money-row `'Voided'`
 * (ADR-016).
 */
export function isNotReportedResolution(
  resolvedAs: TriageResolvedAs | null,
): boolean {
  return resolvedAs === 'Excluded' || resolvedAs === 'Voided';
}
